/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelhistoryempty2Inputs */

const en_channelhistoryempty2 = /** @type {(inputs: Channelhistoryempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing sent yet.`)
};

const de_channelhistoryempty2 = /** @type {(inputs: Channelhistoryempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nichts gesendet.`)
};

/**
* | output |
* | --- |
* | "Nothing sent yet." |
*
* @param {Channelhistoryempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelhistoryempty2 = /** @type {((inputs?: Channelhistoryempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelhistoryempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelhistoryempty2(inputs)
	return de_channelhistoryempty2(inputs)
});
export { channelhistoryempty2 as "channelHistoryEmpty" }